import { CustomEventWithoutDetail, html, on, rune, View } from 'rune-ts';
import klass from './CreatorInputFile.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { each, find, isNull, map, pipe, throwIf, toArray } from '@fxts/core';
import { loading, loadingEnd, upload } from '../../../../../shared/client/global';
import { Alert } from '../../../../components/cells/Alert/Alert';
import { FileItem } from './CreatorFileItem';

export class FileChangeEvent extends CustomEventWithoutDetail {}

export class CreatorInputFile extends View {
  files = '[]';

  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    return html`
      <div class="${klass.form_item}">
        <label
          class="${klass.form_label} ${typoPcMo({
            is_mobile,
            pc: '16_bold',
            mo: '14_bold',
          })} form__label"
          for="creator_advance_reservation_file_input"
          >${ET('mps2::ad_res::portfolio_file')}</label
        >
        <p class="${klass.form_desc} file_form_desc">${ET('mps2::ad_res::portfolio_file_validation')}</p>
        <label class="${klass.form_file}">
          <span class="${klass.form_file_label}">${ET('mps2::ad_res::file_upload')}</span>
          <input
            id="creator_advance_reservation_file_input"
            type="file"
            multiple
            maxlength="3"
            accept="image/jpg, image/jpeg, image/png, .ppt, .pptx, .key, .pdf"
          />
        </label>
        <ul class="${klass.file_list}"></ul>
      </div>
    `;
  }

  @on('change', 'input[type="file"]')
  async fileUpload(e) {
    const files = e.target.files as File[];
    const file_list = pipe(
      this.element().querySelector<HTMLElement>(`ul.${klass.file_list}`),
      throwIf(isNull),
    );
    const uploaded = this.element().querySelectorAll<HTMLElement>(`ul.${klass.file_list} > li`);

    if (!files) return;

    if (files.length > 3 || files.length + uploaded.length > 3) {
      return Alert.open({
        title: ET('mps2::ad_res::file_upload_count_error_title'),
        message: html.preventEscape(ET('mps2::ad_res::file_upload_count_error_desc')),
        confirmText: ET('mps2::ad_res::file_upload_confirm'),
      });
    }

    const overSizeFile = pipe(
      files,
      find((file) => file.size > 1024 * 1024 * 50),
    );

    if (overSizeFile) {
      return Alert.open({
        title: ET('mps2::ad_res::file_upload_size_error_title'),
        message: html.preventEscape(ET('mps2::ad_res::file_upload_size_error_desc')),
        confirmText: ET('mps2::ad_res::file_upload_confirm'),
      });
    }

    loading();
    box.set('ad_res->files', false);

    try {
      await pipe(
        upload(e.currentTarget, {
          url: '/@api/mp_shop/app/file_upload',
        }),
        map((file) => new FileItem({ url: file.url, file_id: file.id, original_name: file.original_name })),
        each((li) => {
          file_list.append(li.render());
          box.set('ad_res->files', true);
          loadingEnd();
        }),
      );
      this.setValue();
      this.dispatchEvent(FileChangeEvent, { bubbles: true });
    } catch (e) {
      loadingEnd();
      return Alert.open({
        title: ET('mps2::ad_res::file_upload_error_title'),
        message: html.preventEscape(ET('mps2::ad_res::file_upload_error_desc')),
        confirmText: ET('mps2::ad_res::file_upload_confirm'),
      });
    }
  }

  @on('click', `.${klass.file_list} li`)
  deleteFile(e) {
    const $target = e.currentTarget;
    if ($target.querySelector(`.${klass.btn_delete_file}`) === e.target) {
      $target.remove();
    }
    this.setValue();
    this.dispatchEvent(FileChangeEvent, { bubbles: true });
  }

  getValue() {
    return this.files;
  }

  setValue() {
    this.files = pipe(
      this.element().querySelectorAll(`.${klass.file_list} li`),
      map((li) => ({
        id: li.getAttribute('file_id'),
        name: li.getAttribute('name'),
        url: li.getAttribute('url'),
      })),
      toArray,
      JSON.stringify,
    );
  }

  isValidate() {
    return this.files !== '[]';
  }
}
